import axios from "axios";

export default () => {
  axios.defaults.headers.common["crossDomain"] = true;
  axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
  axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";

  axios.defaults.timeout = 10000; // timeout 10 sec
  // axios.interceptors.request.use(
  //   (config) => {
  //     const token = localStorage.getItem("access_token");
  //     config.headers = {
  //       "X-User-Email": "anuwat@outputstream.net",
  //       "X-User-Token": "Cw7C42a5EseQ4nHoJyd6",
  //       // Authorization: token,
  //     };
  //     return config;
  //   },
  //   (error) => {
  //     return Promise.reject(error);
  //   }
  // );

  axios.interceptors.response.use(
    (response) => {
      if (response.status === 200 || response.status === 201) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    },
    (error) => {
      if (error.response.status) {
        switch (error.response.status) {
          case 400:
            //do something
            break;

          case 401:
            // session expired
            break;
          case 403:
            // to login agin
            // router.replace({
            //   path: "/login",
            //   query: { redirect: router.currentRoute.fullPath },
            // });
            break;
          case 404:
            // alert("page not exist");
            break;
          case 502:
          // setTimeout(() => {
          //   router.replace({
          //     path: "/login",
          //     query: {
          //       redirect: router.currentRoute.fullPath,
          //     },
          //   });
          // }, 1000);
        }
        return Promise.reject(error.response);
      }
    }
  );
};
